<template>
  <div>
    <div class="mb-2">
      <v-radio-buttons
        id="item-config-media-media-type"
        label="word.media_type"
        button-style="blocks"
        :choices="MEDIA_TYPE_CHOICES"
        v-model="mediaType"
        :horizontal="true"
      />
    </div>
    <div>
      <div class="mb-2" v-if="mediaType">
        <v-text-input
          id="item-config-media-title"
          :required="true"
          v-model="formData.title"
          :errors="errors.title"
          label="word.title"
          size="lg"
        />
      </div>

      <div v-if="mediaType === 'video'">
        <v-text-input
          id="item-config-media-youtube-id"
          label="phrase.youtube_id"
          help-text="sentence.youtube_id_help_text"
          v-model="youtubeUrlOrId"
          :errors="errors.youtube_id"
          :auto-focus="true"
        />
      </div>
      <div v-if="mediaType === 'audio'">
        <label for="item-config-media-audio-file">
          <strong>{{ $t('word.audio_file') }}</strong>
        </label>
        <div>
          <input
            type="file"
            accept="audio/*"
            id="item-config-media-audio-file"
            @change="storeMediaFile"
          />
          <div>
            <small class="text-muted">{{ $t('phrase.max_10_mb') }}</small>
          </div>
        </div>
      </div>
      <div v-show="mediaType === 'image'">
        <label for="item-config-media-image-file">
          <strong>{{ $t('word.image_file') }}</strong>
        </label>
        <div>
          <input
            type="file"
            accept="image/*"
            id="item-config-media-image-file"
            @change="storeMediaFile"
          />
          <div>
            <small class="text-muted">{{ $t('phrase.max_10_mb') }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextInput from '@/common/components/inputs/TextInput.vue';
import RadioButtons from '@/common/components/inputs/RadioButtons.vue';
import { MEDIA_TYPE_CHOICES } from '@/organisation/constants';
import { getIdFromURL } from 'vue-youtube-embed';
import { notify } from '@/common/utils/notify';

export default {
  name: 'ItemConfigMedia',
  components: {
    'v-text-input': TextInput,
    'v-radio-buttons': RadioButtons,
  },
  props: {
    formData: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      MEDIA_TYPE_CHOICES,
      mediaType: '',
      youtubeUrlOrId: '',
    };
  },
  watch: {
    mediaType(value) {
      this.formData.title = this.getMediaTitle(value);
      this.youtubeUrlOrId = '';
      this.formData.media_file = null;
      this.formData.youtube_id = null;
      this.formData.is_video = value === 'video';
      this.formData.is_audio = value === 'audio';
      this.formData.is_image = value === 'image';
    },
    youtubeUrlOrId(value) {
      if (!value) {
        this.formData.youtube_id = null;
        return;
      }
      const youtubeId = getIdFromURL(value);
      if (youtubeId) {
        this.formData.youtube_id = youtubeId;
      } else {
        notify('sentence.youtube_id_not_found', 'error');
      }
    },
  },
  methods: {
    getMediaTitle(value) {
      return this.$t(`word.${value}`);
    },
    storeMediaFile(event) {
      const file = event.target.files[0];
      if (!file) {
        this.formData.media_file = null;
        return;
      }
      file.url = URL.createObjectURL(file);
      this.formData.media_file = file;
    },
  },
};
</script>
